import { Link } from "react-router-dom";
import { useTranslation } from "../../../i18n/LanguageProvider";

function ContactInfo() {
    const { t, localizedPath } = useTranslation();

    return (
        <section className="contacts__info card-common" aria-labelledby="contact-info-title">
            <h2 id="contact-info-title">{t("contact.infoTitle")}</h2>

            <div className="contacts__item">
                <span className="contacts__icon" aria-hidden="true">
                    T
                </span>
                <div>
                    <strong>{t("contact.phone")}</strong>
                    <a href="tel:+37368680112">+373 68 680 112</a>
                </div>
            </div>

            <div className="contacts__item">
                <span className="contacts__icon" aria-hidden="true">
                    E
                </span>
                <div>
                    <strong>{t("contact.email")}</strong>
                    <a href="mailto:ellemoldova1@gmail.com">ellemoldova1@gmail.com</a>
                </div>
            </div>

            <div className="contacts__item">
                <span className="contacts__icon" aria-hidden="true">
                    MD
                </span>
                <div>
                    <strong>{t("contact.country")}</strong>
                    <p>{t("contact.countryValue")}</p>
                </div>
            </div>

            <p className="contacts__note">
                {t("contact.note")} <Link to={localizedPath("/politica-de-confidentialitate")}>{t("legal.privacyTitle")}</Link>.
            </p>
        </section>
    );
}

export default ContactInfo;
